export const getTabProps = (index: number) => ({
  id: `tab-${index}`,
  'aria-controls': `tabPanel-${index}`,
});
